import { createSelector } from 'reselect'

export const getAdditionalLoading = createSelector(
  state => Boolean(state && state.user && state.user.list && state.user.list.isAdditionalLoading),
  isAdditionalLoading => isAdditionalLoading
)
